let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4SIB2")).then(() => parcelRequire('cVaB9'));